import script from "./PaywallTimer.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallTimer.vue?vue&type=script&setup=true&lang=js"

import "./PaywallTimer.vue?vue&type=style&index=0&id=8c7a598a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c7a598a"]])

export default __exports__